/* @flow */

import { rem } from 'polished';

import { accentFontFamily, baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    margin: [16, 0],

    fontFamily: accentFontFamily,
    fontSize: rem(36, baseFontSize),
    fontWeight: 700,
    letterSpacing: -1,
    lineHeight: 40 / 36,
    WebkitFontSmoothing: 'antialiased',
  },
  'root-small': {
    margin: [12, 0],

    fontSize: rem(26, baseFontSize),
    lineHeight: 1,
  },
};
